/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserAccountSearchResultItemDto { 
    fullName?: string;
    id?: string;
    role?: UserAccountSearchResultItemDto.RoleEnum;
    username?: string;
}
export namespace UserAccountSearchResultItemDto {
    export const RoleEnum = {
        RoleRootAdmin: 'ROLE_ROOT_ADMIN',
        RoleProgramAdmin: 'ROLE_PROGRAM_ADMIN',
        RoleProgramAll: 'ROLE_PROGRAM_ALL',
        RoleProgramAssigned: 'ROLE_PROGRAM_ASSIGNED'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


